import React from 'react';

/**
 * What the reading pane shows with nothing open: the client's plugin section
 * (DelAir: the folder's categories and customers), given the mailbox `api`,
 * the `folder`, the list's `query` (its filters, as sent to the service) and
 * `onFilter`. Without one, the usual prompt.
 *
 * An unread / flagged / oldest-unread section was here and was removed
 * (2026-09-29) to load faster: three more Graph reads per folder.
 */
const Overview = ({ api, folder, tick, query, onFilter, Extra }) => {
  if (Extra && folder) {
    return <Extra api={api} folder={folder} tick={tick} query={query} onFilter={onFilter} />;
  }
  return <div className="text-sm text-gray-500">Select a message to read it.</div>;
};

export default Overview;
